/* eslint-disable no-extend-native */

export const extendArrayWithContains = () => {
    if (!("contains" in Array.prototype)) {
        Array.prototype.contains = function (obj) {
            return Array.prototype.includes.call(this, obj);
        };
    }
};
